package dk.smark.demo

import androidx.compose.animation.AnimatedVisibility
import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.safeContentPadding
import androidx.compose.material3.Button
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.tooling.preview.Preview
import dk.smark.demo.location.GenericLocation
import dk.smark.demo.ui.HomeScreen
import dk.smark.demo.ui.LoginScreen
import dk.smark.demo.ui.ProfileScreen
import dk.smark.demo.ui.theme.AppTheme
import org.koin.compose.viewmodel.koinViewModel

@Composable
@Preview
fun App(mapComponent: @Composable (location: GenericLocation) -> Unit = {},
        onUserLocationFound: (lat: Double, lon: Double) -> Unit = {_, _ -> },
        onTrackAvailable: (track: List<GenericLocation>) -> Unit = { _ -> },
        bannerAd: @Composable () -> Unit = {}) {
    AppTheme {
        val viewModel: MainViewModel = koinViewModel()
        var isLoggedIn by remember { mutableStateOf(false) }
        var isCheckingCredentials by remember { mutableStateOf(true) }
        var showProfile by remember { mutableStateOf(false) }

        LaunchedEffect(Unit) {
            if (!FeatureFlags.LOGIN_ENABLED) {
                // Skip login entirely — go straight to the app
                isLoggedIn = true
                isCheckingCredentials = false
                return@LaunchedEffect
            }
            val saved = viewModel.getSavedCredentials()
            if (saved != null) {
                viewModel.login(
                    email = saved.email,
                    password = saved.password,
                    rememberMe = true,
                    onSuccess = { isLoggedIn = true },
                    onError = {
                        // Saved credentials are no longer valid — clear them
                        viewModel.clearSavedCredentials()
                    }
                )
            }
            isCheckingCredentials = false
        }

        when {
            isCheckingCredentials -> Box(
                modifier = Modifier.fillMaxSize(),
                contentAlignment = Alignment.Center
            ) {
                CircularProgressIndicator()
            }
            isLoggedIn -> {
                if (showProfile) {
                    ProfileScreen(
                        viewModel = viewModel,
                        onLogout = {
                            isLoggedIn = false
                            showProfile = false
                        },
                        onBack = { showProfile = false }
                    )
                } else {
                    HomeScreen(
                        viewModel,
                        mapComponent,
                        onUserLocationFound,
                        onTrackAvailable,
                        bannerAd,
                        onProfileClick = { showProfile = true }
                    )
                }
            }
            else -> LoginScreen(onLoginSuccess = { isLoggedIn = true }, viewModel = viewModel)
        }
    }
}